var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 91,
    viewBox: "0 0 54 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 36.4168L14.75 33.7335L24.55 23.0002L14.75 12.2668L17.2 9.5835L27 20.3168L36.8 9.5835L39.25 12.2668L29.45 23.0002L39.25 33.7335L36.8 36.4168L27 25.6835L17.2 36.4168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97054 45.1113C5.22366 44.5156 5.78054 44.1738 6.34585 44.2617L27.0008 47.25L47.6558 44.2617C48.2212 44.1836 48.778 44.5254 49.0312 45.1113L52.5496 53.2559C53.309 55.0039 52.499 57.1231 50.879 57.6602L37.0921 62.2207C35.9193 62.6113 34.6621 62.0352 34.0377 60.8242L27.0008 47.25L19.964 60.8242C19.3396 62.0352 18.0824 62.6113 16.9096 62.2207L3.13116 57.6602C1.50272 57.1231 0.70116 55.0039 1.46054 53.2559L4.97054 45.1113ZM27.0937 53.5L31.7258 62.4258C32.983 64.8477 35.489 66 37.843 65.2188L48.6008 61.6641V77.9727C48.6008 80.1211 47.3352 81.9961 45.5296 82.5234L28.3087 87.5039C27.448 87.7578 26.5452 87.7578 25.693 87.5039L8.4721 82.5234C6.66647 81.9863 5.40085 80.1113 5.40085 77.9629V61.6543L16.1671 65.2188C18.5127 66 21.0271 64.8477 22.2843 62.4258L26.908 53.5H27.0937Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoaIcon);
export default __webpack_public_path__ + "static/media/DoaIcon.8253000c52cf2bc4b92ec9e94e5f6363.svg";
export { ForwardRef as ReactComponent };